import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com'
      className='link footer__link'
    >
      Created By Lalit Malviya
    </a>
  </footer>
)

export default Footer
